import styles from "./highlight.module.scss";

const HighLights = ({
  highlights = [],
  isRajasthan = false,
  isMadhya = false,
  isHR = false,
  isUP = false,
  isBH = false,
  isCGH = false,
  isUK = false,
}) => {
  if (highlights.length > 5) {
    highlights.length = 5;
  }
  // console.log("the highlights are" , highlights)
  return (
    <>
      <div className={styles.outerContainer}>
        <div
          className={`${styles.TitleDiv} ${
            isRajasthan
              ? "text-rajasthanDark bg-rajasthanLight"
              : isMadhya
              ? "text-mpDark bg-mpLight"
              : isHR
              ? "text-hrDark bg-hrLight"
              : isBH
              ? "text-biharDark bg-biharLight"
              : isUP
              ? "text-upDark bg-upLight"
              : isCGH
              ? "text-mpDark bg-mpLight"
              : isUK
              ? "text-ukDark bg-ukLight"
              : "text-primary bg-red-500 bg-opacity-20"
          }`}
        >
          ▌ <h2 className={styles.Heading}>न्यूज़ हाइलाइट्स</h2>
        </div>
        <div className={styles.SubHead}>
          {highlights.map((item, index) => {
            return (
              <div key={index} className={styles.rightArrow}>
                <img
                  style={{ maxWidth: "12px" }}
                  src={`${
                    isRajasthan
                      ? "https://akm-img-a-in.tosshub.com/lingo/uptak/resources/rj-tak-icon.png"
                      : isMadhya
                      ? "https://akm-img-a-in.tosshub.com/lingo/uptak/resources/mptak-icon.png"
                      : isCGH
                      ? "https://akm-img-a-in.tosshub.com/lingo/uptak/resources/mptak-icon.png"
                      : isUK
                      ? "https://akm-img-a-in.tosshub.com/lingo/uptak/resources/mptak-icon.png"
                      : "https://akm-img-a-in.tosshub.com/lingo/uptak/resources/news-tak-icon.png"
                  }`}
                  alt="point"
                ></img>{" "}
                <p className={styles.Content}>{item.title}</p>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default HighLights;
